// removed by extract-text-webpack-plugin
module.exports = {"modules":"src-display-platform-HelpCenter-index__modules--NOkrZ","info":"src-display-platform-HelpCenter-index__info--3Tl3r","title":"src-display-platform-HelpCenter-index__title--7Hjh1","content":"src-display-platform-HelpCenter-index__content--3ULyN","contentTitle":"src-display-platform-HelpCenter-index__contentTitle--1v_nU","contentIcon":"src-display-platform-HelpCenter-index__contentIcon--K9ZpV","phoneIcon":"src-display-platform-HelpCenter-index__phoneIcon--2MhSp","emailIcon":"src-display-platform-HelpCenter-index__emailIcon--2UdQm","goback":"src-display-platform-HelpCenter-index__goback--3K2jB"};


//////////////////
// WEBPACK FOOTER
// ./src/display/platform/HelpCenter/index.scss
// module id = 1073
// module chunks = 0